import Choice from './Choice';

export { Props, Error, errorID, helpTextID } from './Choice';
export default Choice;
